export default "__VITE_PUBLIC_ASSET__a7b3680a__"